export default {"src":"/_next/static/media/fb.2651231e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};